import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../baseAuthQuery";
import { IBillDTO, IBillListDTO } from "../../Interfaces/Bill";

export const BillApi = createApi({
    reducerPath: "BillApi",
    baseQuery: baseAuthQuery,
    tagTypes: ["Bill"],
    endpoints: (builder) => ({
        createBillFromOffer: builder.mutation<IBillListDTO, number>({
            query: (offerId: number) => ({
                url: `/Bill/${offerId}`,
                method: "POST",
            })
        }),
    }),
})

export const { useCreateBillFromOfferMutation } = BillApi